"use client";

import { Trans } from "@lingui/react/macro";

export const VehicleSelectionLimitMessage = ({
	maxVehicles,
	selectedCount,
	hasVehicleChangesLeft = true,
}: {
	maxVehicles: number;
	selectedCount: number;
	hasVehicleChangesLeft?: boolean;
}) => {
	if (selectedCount === 0) {
		return (
			<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit and nothing is selected yet">
				Select up to {maxVehicles} vehicles for this permit
			</Trans>
		);
	}
	if (!hasVehicleChangesLeft) {
		return (
			<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit and the permit has no self-service vehicle changes left, so only its current vehicles can be re-selected">
				<b>{selectedCount} selected.</b> No vehicle changes left.
			</Trans>
		);
	}
	if (selectedCount >= maxVehicles) {
		return (
			<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit and the limit is reached, so the remaining vehicles are disabled">
				<b>Max of {maxVehicles} selected.</b> Deselect one to change.
			</Trans>
		);
	}
	const remainingCount = maxVehicles - selectedCount;
	return (
		<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit with some vehicles selected and room for more">
			{selectedCount} selected. You can add {remainingCount} more.
		</Trans>
	);
};
